

export const REACT_APP_SOCKET_URL="https://auth.loop.fans"
export const REACT_APP_CHAIN_PREFIX = "juno"

export const REACT_APP_RPC = "https://rpc-juno.itastakers.com"
export const SMALLEST = 1000000